import React from 'react';
import { PageTypes } from 'core/constant/analytics/PageTypes';
import { connect } from 'react-redux';
import { Footer } from '@agoda/layout';
import { load } from 'core/utils/DynamicPreloading';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { MobilePageTypes } from 'core/constant/analytics/MobilePageTypes';
import { Optional } from 'core/type/generic';
import { FooterType } from 'core/type/behaviors.types';
import { ActivitiesFooterProps, mapStateToProps } from 'component/common/Footer/ActivitiesFooter.selectors';

const FooterAgoda = React.lazy(load(() => import('component/common/Footer/FooterAgoda')));
const FooterEnterpriseWhitelabel = React.lazy(load(() => import('component/common/Footer/FooterEnterpriseWhitelabel')));

const showFooterByBehavior = (config: BootstrapConfig): boolean => {
    if (!config.behavior) return false;
    const pageTypeId = config.pageConfig.pageTypeId;

    switch (pageTypeId) {
        case PageTypes.Home:
        case MobilePageTypes.Home:
            return config.behavior.home.showFooter;
        case PageTypes.Search:
        case MobilePageTypes.Search:
            return config.behavior.search.showFooter;
        case PageTypes.Details:
            return config.behavior.detail.showFooter;
        case PageTypes.City:
        case MobilePageTypes.City:
            return config.behavior.city.showFooter;
        default:
            return false;
    }
};

// @ts-ignore
const FooterMap: { [key in FooterType]: Optional<React.LazyExoticComponent<React.FC<{ hidden?: boolean }>>> } = {
    [FooterType.B2C_FOOTER]: FooterAgoda,
    [FooterType.B2B_FOOTER]: FooterEnterpriseWhitelabel,
};

const ActivitiesFooter: React.FC<ActivitiesFooterProps> = React.memo((props) => {
    // @ts-ignore
    const FooterComponent = FooterMap[props.footer?.footerEnum];
    const shouldShowFooter = showFooterByBehavior(props.config);

    if (!FooterComponent || !shouldShowFooter) {
        return null;
    }

    if (props.config?.behavior?.common?.isRtaFooterEnabled) {
        return <Footer featureConfigs={{ RtaHeaderFooter: {} }} />;
    }

    return (
        <React.Suspense fallback={null}>
            <FooterComponent hidden={props.textSearchOverlayVisible} />
        </React.Suspense>
    );
});
ActivitiesFooter.displayName = 'ActivitiesFooter';

const ActivitiesFooterWithStore = connect(mapStateToProps)(ActivitiesFooter);
export { ActivitiesFooterWithStore as ActivitiesFooter };
